import  {useContext } from "react";
import VisitorContext from '../VisitorContext.jsx'
import Popup from 'reactjs-popup';
import deleteIcon from '../../../assets/delete.png';

const DeletePopup = ({ id }) => {
    const { deleteVisitor, visitors, clearGuardianIfOrphaned, markGuardianMissing } = useContext(VisitorContext)

    const toDelete = visitors.find(v => v.id === id);

    const handleDelete = () => {
        if (toDelete?.visitor_is_minor && toDelete?.guardian_id) {
            clearGuardianIfOrphaned(toDelete.guardian_id, id);
        }
        if (toDelete?.person_is_guardian) {
            markGuardianMissing(id);
        }
        deleteVisitor(id);
    }
    return (
        <Popup trigger={<img src={deleteIcon} />} modal className="popup-content__delete" >
            {close => (
                <div className="confirm-popup">
                    <div className="confirm-popup__header">
                        Remove {toDelete?.visitor_first_name} {toDelete?.visitor_last_name}?
                    </div>
                    <div className="formButtons">
                        <button className="button delete" onClick={handleDelete}>Remove</button>
                        <button className="button close" onClick={close}>No</button>
                    </div>
                </div>
            )}
        </Popup>
    )}





export default DeletePopup